import { LvLogResult } from "interface/carenet/lv"
import { MrpLogResult } from "interface/carenet/mrp"

export type SourceType = 'mrp' | 'lv'
export const toSourceType = (source: string): SourceType | null => (
	source === 'mrp' ? 'mrp' :
	source === 'lv' ? 'lv' : null
) 
export type SourceProject = {
	source: SourceType
	isOrigin?: boolean
	projectId?: number
	projectCode?: string
	projectName: string
	productName: string | null
	projectDate: Date | null
	logList: (MrpLogResult | LvLogResult)[]
}

export const JournalERAMap: { [index: string]: string } = {
	'F': '10年前のみ',
	'F>M': '10年前中心',
	'F>M>N': '全般',
	'F>N': '10年前中心',
	'F>N>M': '全般',
	'M': '5～10年前のみ',
	'M>F': '5～10年前中心',
	'M>F>N': '全般',
	'M>N': '5～10年前中心',
	'M>N>F': '全般',
	'N': '5年以内のみ',
	'N>M': '5年以内中心',
	'N>M>F': '全般',
	'N>F': '5年以内中心',
	'N>F>M': '全般',
} as const
